import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';

const StandaloneStatusStyledButton = styled(Button)`
  border-radius: 20px !important;
  background-color: var(--button-grey) !important;
  border-color: var(--button-grey) !important;
  color: #000 !important;
  font-family: Circular-Bold;
  font-size: 12px !important;
  margin: 0 5px;
  height: 34px;

  ${({ active }) =>
    active &&
    `
    border-color: var(--ultramarine-blue) !important;
    border-width: 2px !important;
  `};
`;

export default props => {
  return (
    <StandaloneStatusStyledButton
      onClick={props.onClick}
      active={props.active}
      disabled={props.disabled}
    >
      {props.children}
    </StandaloneStatusStyledButton>
  );
};
